import type { Profile } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCompleteOnboardingTourMutation } from '../../queries';
import { InfoStep } from '../info-step';

const FinishStep = ({ onFinish, viewer }: { onFinish: () => void; viewer: Profile }) => {
  const { t } = useTranslation();
  const { isPending: isLoading, mutate: finishOnboardingTour } = useCompleteOnboardingTourMutation();

  const handleFinish = useCallback(() => {
    finishOnboardingTour(
      {},
      {
        onSuccess: onFinish,
      },
    );
  }, [finishOnboardingTour, onFinish]);

  return (
    <InfoStep
      description="Thank you for signing up! Now you're ready to enjoy the app."
      primaryButton={{ children: 'Let’s go', loading: isLoading, onClick: handleFinish }}
      title={t('Welcome {{firstName}}!', { firstName: viewer.firstName })}
    />
  );
};

export default FinishStep;
